<template>
  <v-container>
    <v-form class="col-lg-8 col-11 contact-form pink lighten-5 register-form">
      <v-row>
        <v-text-field label="First name"/>
        <v-text-field label="Last name"/>
      </v-row>
      
      <v-row>
        <v-text-field label="Country" />
      </v-row>

      <v-row>
        <v-text-field label="state" />
      </v-row>

      <v-row>
        <v-text-field label="Email" />
      </v-row>

      <v-row>
        <v-text-field label="Password" />
      </v-row>

      <v-row>
        <v-text-field label="Confirm password" />
      </v-row>

      <v-row>
        <v-btn>Submit</v-btn>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: 'registration-form'
}
</script>

<style scoped>
.register-form {
  padding: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0.5rem;
  box-shadow: -0.5px 1.5px 0.25rem 0.5px rgba(0,0,0,0.25)
}
</style>